// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"9342829d","167":"950b0a91"}[chunkId] + ".chunk.js";
};